import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { TweenMax, TimelineLite, Power3 } from "gsap";
import arrow from "./images/arrow-right.svg";

function Home() {
  // referencing DOM elements with useRef
  let hero = useRef(null);
  let content = useRef(null);
  //once the entire page is loaded the timeline will wait .2s
  let tl = new TimelineLite({ delay: 0.2 });
  useEffect(() => {
    //Content variables:
    const headlineFirst = content.children[0].children[0];
    const headlineSecond = headlineFirst.nextSibling;
    const headlineThird = headlineSecond.nextSibling;
    const headlineFourth = headlineThird.nextSibling;

    const contentP = content.children[1];
    const contentButton = content.children[2];
    // 'to' - defines final state, 'from' defines initial state

    // removing initial flash, at the beginning the visibility is hidden until all dom elements are loaded:
    // TweenMax makes the dom visible right away
    // TARGET, DURATION, CONFIGURATION:
    TweenMax.to(hero, 0, { css: { visibility: "visible" } });

    //CONTENT ANIMATION:
    tl.staggerFrom(
      [
        headlineFirst.children,
        headlineSecond.children,
        headlineThird.children,
        headlineFourth.children,
      ],
      1,
      {
        y: 44,
        ease: Power3.easeOut,
        delay: 0.8,
        // .15 seconds  = achieving the staggeting (domino) effect:
      },
      0.15,
      "start"
    )
      // syncing two timelines with any matching string , here: 'start'. For 2 timelines to work together
      .from(contentP, 1, { y: 20, opacity: 0, ease: Power3.easeOut }, 1.4)
      .from(contentButton, 1, { y: 20, opacity: 0, ease: Power3.easeOut }, 1.6);
  });

  return (
    <div className="hero" ref={(el) => (hero = el)}>
      <div className="hero-container">
        <div className="hero-inner">
          <div className="hero-content">
            <div className="hero-content-inner" ref={(el) => (content = el)}>
              <h1>
                {/* hero-content-line is not moving on animation, but hero-content-line-inner IS */}
                <div className="hero-content-line">
                  <div className="hero-content-line-inner p-head">
                    Hi, my name is{" "}
                    <span className="name-span">Ishaan Tyagi</span>.
                  </div>
                </div>

                <div className="hero-content-line">
                  <div className="hero-content-line-inner p-head">
                    Welcome to my portfolio.
                  </div>
                </div>

                <div className="hero-content-line">
                  <div className="hero-content-line-inner">
                    I build websites <span className="red">&</span>
                  </div>
                </div>

                <div className="hero-content-line">
                  <div className="hero-content-line-inner">
                    have a lot of fun with it.
                  </div>
                </div>
              </h1>

              <p>
                Frontend Developer<span className="red">/</span> Web Developer
              </p>

              <div className="btn-row">
                <button className="explore-button">
                  Explore my work
                  <Link to="/projects" className="arrow-icon">
                    <img src={arrow} alt="arrow" />
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="home--about"></div>
        <footer className="wrapper">
          <h6>&copy; Copyright 2023 Ishaan Tyagi</h6>
        </footer>
      </div>
    </div>
  );
}

export default Home;
